import { ICache } from "../provider/provider-interfaces";
import { LocalStorageManager } from "../storage/local-storage-manager";
import { KeyExistsError } from "../exception/key-exists-error";
import { Logger } from "../../logger/logger";

let localStorageManager = LocalStorageManager.getInstance();
let cacheIdKey = "cache-id";
let cachePrefix = "cached-";

let has = (key: string) => {
	return localStorageManager.hasItem(cachePrefix + key);
};

let clear = (prefix: string = "") => {
	return localStorageManager.clearWithPrefix(cachePrefix + prefix);
};

let add = <T>(key: string, value: T) => {
	if (has(key)) {
		throw new KeyExistsError(key, KeyExistsError.keyExistsText);
	}
	localStorageManager.setItemToJson(cachePrefix + key, value);
};

let addOrUpdate = <T>(key: string, value: T) => {
	localStorageManager.setItemToJson(cachePrefix + key, value);
};

let remove = (key: string) => {
	localStorageManager.removeItem(cachePrefix + key);
};

let get = <T>(key: string) => {
	return localStorageManager.getItemFromJson<T>(cachePrefix + key);
};

let cacheIdChanged = (cacheId: string) => {
	if (!localStorageManager.hasItem(cacheIdKey)) {
		return true;
	}
	return localStorageManager.getItemFromJson<string>(cacheIdKey) !== cacheId;
};

let setCacheId = (cacheId: string) => {
	localStorageManager.setItemToJson(cacheIdKey, cacheId);
};

let initializeCache = (cacheId: string) => {
	if (cacheIdChanged(cacheId)) {
		localStorageManager.clearWithPrefix(cachePrefix);
		setCacheId(cacheId);
	}
};

export const localStorageCache: ICache = {
	initializeCache,
	has,
	get,
	add,
	addOrUpdate,
	remove,
	clear
};